<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <v-card height="100%">
            <v-toolbar dark color="blue">
                <v-toolbar-title>Documento</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="show = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <VueDocPreview :value="docValue" :type="docType" />
        </v-card>
    </v-dialog>
</template>

<script>
import VueDocPreview from 'vue-doc-preview'
export default {
    data: (vm) => ({
        docValue: "",
        docType: "office",
        ruta: "",
        height: "100%",
    }),

    props: ["visible", "doc"],

    components: {
        VueDocPreview
    },

    computed: {
        show: {
            get() {
                if (this.doc != "") {
                    this.docValue =
                        `https://api.icssa.com.ar/Direccion/InfDireccion/${this.doc}.doc?${Math.random()}`;
                    // this.createIframe();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },

    }
}
</script>